(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-location-name-input.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-location-name-input.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _jotai = jotai,
  useAtom = _jotai.useAtom,
  useSetAtom = _jotai.useSetAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  lyckoplatsenNameAtom = _svs$lyckoplatsen$com.lyckoplatsenNameAtom,
  shouldDisablePayButtonAtom = _svs$lyckoplatsen$com.shouldDisablePayButtonAtom;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Inputv2 = _svs$ui$reactForm.Inputv2;
const getDefaultLocationName = svs.tur.lyckoplatsen.utils.getDefaultLocationName;
const validateInputName = text => {
  const hasRegexUnicodeSupport = new RegExp().unicode === false;
  const allowedCharactersRegex = /[A-Za-z0-9-_!°'" áéíóúýæþðåäöÁÉÍÓÚÝÆÞÐÅÄÖ]+/g;
  const allowedEmojisRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  const allowedVariationSelectorsRegex = /[\uFE00-\uFE0F]/g;
  if (typeof text !== 'string') {
    throw Error('must be a string');
  }
  text = text.replace(allowedCharactersRegex, '');
  if (hasRegexUnicodeSupport) {
    text = text.replace(allowedEmojisRegex, '');
    text = text.replace(allowedVariationSelectorsRegex, '');
  }
  return {
    invalid: text.length > 0,
    text
  };
};
const calculateBytes = input => {
  const encoder = new TextEncoder();
  const byteLength = encoder.encode(input).length;
  return byteLength;
};
const validateByteInput = input => {
  const bytes = calculateBytes(input);
  if (bytes > 50) {
    return true;
  }
  return false;
};
const invalidInput = 'Tillåtna tecken är: A-ö 0-9 -_!°\'" och emojis';
const errorMaxMessage = 'Texten är för lång';
const maxAllowedInput = 32;
const validationHandler = value => {
  let errorMessage = '';
  const _validateInputName = validateInputName(value),
    invalid = _validateInputName.invalid,
    text = _validateInputName.text;
  if (invalid) {
    errorMessage = "".concat(text, " \xE4r ej till\xE5tet, ").concat('', invalidInput);
  } else if (validateByteInput(value)) {
    errorMessage = 'För många tecken';
  } else if (value.length > maxAllowedInput) {
    errorMessage = "".concat(errorMaxMessage, " ").concat(value.length, "/").concat(maxAllowedInput);
  }
  return errorMessage;
};
const BetslipLocationNameInput = () => {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  const hasError = errorMessage.length > 0;
  const _useAtom = useAtom(lyckoplatsenNameAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    lyckoplatsenName = _useAtom2[0],
    setLyckoplatsenName = _useAtom2[1];
  const setShouldDisablePayButton = useSetAtom(shouldDisablePayButtonAtom);
  const inputEl = document.querySelector('#lyckoplatsenName');
  const validateValue = useCallback(value => {
    const err = validationHandler(value);
    setErrorMessage(err);
    const hasNewError = err.length > 0;
    if (!hasNewError) {
      setShouldDisablePayButton(false);
    } else {
      setShouldDisablePayButton(true);
    }
  }, [setShouldDisablePayButton]);
  useEffect(() => {
    validateValue(lyckoplatsenName);
  }, [lyckoplatsenName, validateValue]);
  const handleChange = e => {
    const value = e.target.value;
    setLyckoplatsenName(value);
    validateValue(value);
  };
  const handleBlur = () => {
    if (lyckoplatsenName.trim().length === 0) {
      setLyckoplatsenName(getDefaultLocationName());
      setShouldDisablePayButton(false);
    }
  };
  const handleFocus = () => {
    inputEl.setSelectionRange(0, 0);
    if (lyckoplatsenName === getDefaultLocationName()) {
      setLyckoplatsenName('');
    }
  };
  const handleSubmit = e => {
    e.preventDefault();
  };
  const handleInputKeyDown = e => {
    if (e.key === 'Enter') {
      inputEl === null || inputEl === void 0 || inputEl.blur();
    }
  };
  return React.createElement(Form, {
    isVertical: true,
    onSubmit: handleSubmit
  }, React.createElement(ControlGroup, {
    v2: true,
    hasError: hasError,
    errorMessage: errorMessage,
    idForInput: "lyckoplatsenName"
  }, React.createElement(Inputv2, {
    autoComplete: "off",
    id: "lyckoplatsenName",
    label: "Namnge din lyckoplats",
    value: lyckoplatsenName,
    type: "text",
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleInputKeyDown
  })));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  BetslipLocationNameInput
});

 })(window);